import { UseFormReturn } from "react-hook-form";
import { InsuranceEntity } from "../entity";
import React, { memo } from "react";
import { Col, FormGroup, FormLabel } from "react-bootstrap";
import { ErrorField, WitLabel } from "../styles";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import DatePicker from "react-datepicker";
import { DATE_FORMAT } from "../../ariManagement/shared/constants";
import { ErrorMessage } from "@hookform/error-message";

const messages = defineMessages({
  validityWindow: { id: "insurance.form.validityWindow", defaultMessage: "Validity (Dates)" },
  validFrom: { id: "insurance.form.validFrom", defaultMessage: "Valid From" },
  validTo: { id: "insurance.form.validTo", defaultMessage: "Valid To" },
  validToShouldBeAfterValidFrom: {
    id: "insurance.form.validToShouldBeAfterValidFrom",
    defaultMessage: "Date should be after Valid From date",
  },
});

export const ValidityWindowComponent = memo((props: UseFormReturn<InsuranceEntity>) => {
  const intl = useIntl();

  return (
    <>
      <FormGroup as={Col}>
        <FormLabel column sm={12}>
          <WitLabel>
            <FormattedMessage {...messages.validityWindow} />
          </WitLabel>
        </FormLabel>
        <FormLabel column sm={12}>
          <FormattedMessage {...messages.validFrom} />
        </FormLabel>
        <Col sm={3}>
          <DatePicker
            {...props.register("validFrom")}
            className="form-control"
            selected={props.watch("validFrom") && props.getValues("validFrom")}
            onChange={(date: Date) => props.setValue("validFrom", date)}
            dateFormat={DATE_FORMAT.DEFAULT}
            minDate={new Date()}
          />
        </Col>
      </FormGroup>

      <FormGroup as={Col}>
        <FormLabel column sm={12}>
          <FormattedMessage {...messages.validTo} />
        </FormLabel>
        <Col sm={3}>
          <DatePicker
            {...props.register("validTo", {
              validate: value => {
                const validFrom = props.getValues("validFrom");
                if (validFrom && value && value < validFrom) {
                  return intl.formatMessage(messages.validToShouldBeAfterValidFrom);
                }
                return true;
              },
            })}
            className="form-control"
            selected={props.watch("validTo") && props.getValues("validTo")}
            onChange={(date: Date) => props.setValue("validTo", date)}
            dateFormat={DATE_FORMAT.DEFAULT}
            minDate={new Date()}
          />
          <ErrorMessage
            errors={props.formState.errors}
            name="validTo"
            render={({ message }) => <ErrorField>{message}</ErrorField>}
          />
        </Col>
      </FormGroup>
    </>
  );
});
